/* GENERATED by scripts/type-icons.mjs. Do not hand-edit: re-run it.
 *
 * The icons that actually exist in public/icons/. The admin's type editor
 * offers exactly these, so it cannot offer one that 404s, and a new icon
 * dropped into that folder appears in the picker on the next run.
 */
export const TYPE_ICONS = [
  "type-apartment",
  "type-building",
  "type-chalet",
  "type-clinic",
  "type-duplex",
  "type-land",
  "type-office",
  "type-penthouse",
  "type-retail",
  "type-storage",
  "type-studio",
  "type-townhouse",
  "type-twinhouse",
  "type-villa",
] as const;

export type TypeIcon = (typeof TYPE_ICONS)[number];

export const isTypeIcon = (v: unknown): v is TypeIcon =>
  typeof v === "string" && (TYPE_ICONS as readonly string[]).includes(v);

/** Where the file lives. One place, so a rename is one edit. */
export const typeIconUrl = (icon: string) => `/icons/${icon}.svg`;
